<template>
  <div :class="classes()">
    <div :class="`${el}__loader`">
      <svg :class="`${el}__circular`" viewBox="25 25 50 50">
        <circle
          :class="{
            [`${el}__path`]: true,
            [`${el}__path--${color}`]: color,
          }"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="4"
          stroke-miterlimit="10"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { ColorTypes } from '@/constants/enums';

export default {
  name: 'Spinner',
  props: {
    color: {
      type: String,
      default: 'primaryCoral',
      validator: (val) => ColorTypes.includes(val),
    },
    size: {
      type: String,
      default: 'm',
      validator: (val) => ['s', 'm', 'l'].includes(val),
    },
    insideWidget: Boolean,
  },
  data() {
    return {
      el: 'o-spinner',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.size}`]: this.size,
          [`${el}--insideWidget`]: this.insideWidget,
        };
      },
    };
  },
};
</script>
